<script>
import Icon from "./ProductIndicatorIcon.vue";
export default {
  components: {
    Icon,
  },
  props: {
    products: {
      type: Array,
      default: () => [
        "fundamentals",
        "architect",
        "landmark",
        "spotlight",
        "braceworks",
        "connectCAD",
        "vision",
      ],
    },
    activeProducts: {
      type: Array,
      default: () => ["braceworks", "vision"],
    },
    size: {
      type: String,
      default: "21px",
    },
    lightColor: {
      type: String,
      default: " var(--color-main-1)",
    },
    darkColor: {
      type: String,
      default: "var(--color-main-2)",
    },
    hoverColor: {
      type: String,
      default: "var(--color-accent-1)",
    },
    gap: {
      type: String,
      default: "8px",
    },
    marginTop: {
      type: String,
      default: "0",
    },
  },

  methods: {
    generateStyles() {
      return {
        "--size": this.size,
        "--light-color": this.lightColor,
        "--dark-color": this.darkColor,
        "--hover-color": this.hoverColor,
        "--gap": this.gap,
        "--tooltip-bg": this.lightColor,
        "--tooltip-color": this.darkColor,
      };
    },
  },
};
</script>
<template>
  <div v-if="products.length > 1" :style="generateStyles()" class="iconGroup">
    <Icon v-for="product in products" :name="product" :is-active="activeProducts.includes(product)" :key="product" />
  </div>
</template>

<style lang="scss" scoped>
div {
  display: flex;
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/ProductIndicator.vue